import type { CalendarSurfaceStore } from 'owa-calendar-surface-dategrid';
import {
    overflowMonthItemTemplate as overflowMonthItemTemplateBase,
    monthItemTemplate as monthItemTemplateBase,
} from 'owa-calendar-surface';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { getCalendarEventColorScheme } from 'owa-calendar-color-resolver';
import { getCharm } from 'owa-calendar-events-store';
import { isCalendarPeekShown } from 'owa-calendar-module-command';
import { shouldShowWeekMonthName } from 'owa-calendar-layout';

/**
 * Default item template for month view
 * @param store: A surface store
 * @param model: A surface item model
 * @param state: A surface state
 */
export const monthItemTemplate = (
    store: CalendarSurfaceStore,
    model: CalendarEvent,
    itemState?: any
): JSX.Element => {
    return monthItemTemplateBase(
        store,
        model,
        getCalendarEventColorScheme(model),
        getCharm(model),
        itemState,
        false /* increaseFontSize */,
        true /* joinButtonVisible */,
        isCalendarPeekShown /* shouldHideTooltip */,
        shouldShowWeekMonthName() /* shouldShowEventStartTime */
    );
};

/**
 * Template for overflow month item
 */
export const overflowMonthItemTemplate = overflowMonthItemTemplateBase;
